import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Global, css } from '@emotion/react';
import { RecoilRoot } from 'recoil';
import useScript from 'react-script-hook';

import Login from "./Components/Public/Login/Login";
import RedirectToken from "./Components/Public/Login/RedirectToken";
import ComponentRoute from "./core/routes/ComponentRoute";
import SecureRoute from "./core/routes/SecureRoute";
import { AwaitingDialogContextProvider } from "./core/contexts/AwaitingDialogContext";
import { AuthContextProvider } from "./core/contexts/AuthContext";
import { ThemeContextProvider } from "./core/contexts/ThemeContext";
import { SpinnerContextProvider } from "./core/contexts/SpinnerContext";
import useAxiosAuth from "./core/hooks/useAxiosAuth";

import "react-notifications/lib/notifications.css";
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

// const defaultTheme = createMuiTheme({
//   palette: {
//     primary: orange
//   }
// });


const globalCss = css`
.nav-border-inline {
  border-top: 4px solid #fff;
  transition: all 0.5s ease;
  &:hover {
    border-top: 4px solid ${window.rucmonkeyGlobalConfigs.styles.primaryColorCode};
    background-color: #dfdddd !important;
    color: ${window.rucmonkeyGlobalConfigs.styles.primaryColorCode};
  }
  &:active {
    background-color: #dfdddd !important;
  }
}
`;

const App = () => {

  useAxiosAuth();
  const [loading] = useScript({ src: "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=" + window.rucmonkeyGlobalConfigs.mapKey });



  return (

    <RecoilRoot>
      {!loading &&
        <ThemeContextProvider>
          <AwaitingDialogContextProvider>
            <SpinnerContextProvider>

              <AuthContextProvider>
                <Global styles={globalCss} />
                <Router>
                  <Switch>
                    <Route exact path="/login" component={Login} />
                    <Route exact path="/" component={Login} />
                    <Route exact path="/redirect/:id" component={RedirectToken} />
                    <SecureRoute path="/" component={ComponentRoute} />
                  </Switch>
                </Router>
              </AuthContextProvider>

            </SpinnerContextProvider>
          </AwaitingDialogContextProvider>
        </ThemeContextProvider>
      }
    </RecoilRoot>

  );
};

export default App;

